import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
  Badge,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { getFromStorage, removeFromStorage, STORAGE_KEYS } from "../helpers";
import { useAppDispatch } from "../hooks/store";
import { resetAuth, setCredentials } from "../reducers/authSlice";
import { useLazyMyProfileQuery } from "../service/auth";
import useAuth from "../hooks/useAuth";
import { toast } from "react-toastify";
import LogoutModal from "../Modals/logoutModal";
import { useGetNotificationsQuery, useMarkAsReadMutation, AppNotification } from "../service/notifications";
import moment from "moment";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [getUser] = useLazyMyProfileQuery();
  const user = useAuth();
  
  const { data: notificationsData } = useGetNotificationsQuery(
    { page: 1, limit: 10 },
    { skip: !user }
  );
  const [markAsRead] = useMarkAsReadMutation();
  const unreadCount = notificationsData?.data?.unreadCount || 0;
  const topNotifications = notificationsData?.data?.list?.slice(0, 5) || [];

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);
  const [openLogout, setOpenLogout] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const getUserDetails = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser({}).unwrap();
        if (result?.statusCode === 200 && token) {
          dispatch(
            setCredentials({
              user: result?.data,
              token: token,
            })
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.credentials);

    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: JSON.parse(`${userData}`),
        })
      );
      getUserDetails();
    }
  }, []);
  const handleLogout = () => {
    dispatch(resetAuth());
    removeFromStorage(STORAGE_KEYS.token);
    removeFromStorage(STORAGE_KEYS.credentials);
    toast.success("Logged out successfully");
    navigate("/");
  };


  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left">
            <IconButton onClick={handleSidebarToggle}>
              <MenuIcon />
            </IconButton>
            {/* <Button className="btn btn_primary sm" onClick={() => {
              window.dispatchEvent(new Event("start-walkthrough"));
            }}>
              Start Walkthrough
            </Button> */}
          </div>
          <div className="topbar_right">
            <Box>


              <IconButton
                id="step-notifications"
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <Badge badgeContent={unreadCount} color="error">
                  <NotificationsActiveIcon />
                </Badge>
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => {
                      navigate("/recieved-notifications");
                      handleClose1();
                    }}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  {topNotifications.length > 0 ? (
                    topNotifications.map((notification: AppNotification) => (
                      <li 
                        key={notification.id || notification._id}
                        style={{ cursor: "pointer", backgroundColor: notification.isRead ? "transparent" : "#f0f8ff" }}
                        onClick={async () => {
                          if (!notification.isRead) {
                            try {
                              const idToMark = notification.id || notification._id;
                              if (idToMark) {
                                await markAsRead({ id: idToMark }).unwrap();
                              }
                            } catch (e) {
                              console.error(e);
                            }
                          }
                          navigate("/recieved-notifications");
                          handleClose1();
                        }}
                      >
                        <figure>
                          <img src={notification.sender?.profileImage || "/static/images/user_placeholder.png"} alt="" />
                        </figure>
                        <div className="noti_info">
                          <Typography component="h3" style={{ fontWeight: notification.isRead ? "normal" : "bold" }}>
                            {notification.sender?.name || "System"}
                            <Typography component="span">{moment(notification.createdAt).fromNow()}</Typography>
                          </Typography>
                          <Typography component="p" style={{ fontWeight: notification.isRead ? "normal" : "bold" }}>
                            {notification.broadcast?.title || notification.title} - {notification.broadcast?.message || notification.message}
                          </Typography>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                      No notifications found
                    </li>
                  )}
                </ul>
              </Menu>
            </Box>

            <Box>
              <IconButton
                id="step-profile"
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img src={(user as any)?.sp?.logo ? (user as any).sp.logo : "/static/images/admin_icon.png"} alt="" />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    navigate("/manage-profile");
                    handleClose();
                  }}
                >
                  <PersonIcon /> My Profile
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("/manage-profile/change-password");
                    handleClose();
                  }}
                >
                  <LockIcon /> Change Password
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    setOpenLogout(true);
                  }}
                >
                  <LogoutIcon /> Logout
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
      <LogoutModal
        open={openLogout}
        setOpen={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
